<div class="toast-container" [@slideDown]="toasts.length" [attr.data-automation-id]="automationId + '-container'">
    <div *ngFor="let toast of toasts; let i=index; trackBy: trackByToastId" class="toast toast-{{toast.type}}"
        [attr.toast-notification-id]="toast.id" [attr.data-automation-id]="automationId + '-' + toast.type + '-message'"
        [ngClass]="{ 'slide-in-from-right': toast.isSlidingInFromRight, 'fade-out': toast.isFadingOut }"
        (mouseenter)="onMouseEnter(toast)" (mouseleave)="onMouseLeave(toast)">
        <div class="toast-content" [attr.data-automation-id]="automationId + '-content'">
            <i class="fa {{getToastIcon(toast.type)}} toast-icon"
                [attr.data-automation-id]="automationId + '-icon'"></i>
            <span class="toast-message" [attr.data-automation-id]="automationId + '-message'"
                [innerHTML]="toast.message"></span>
            <button type="button" class="toast-close" (click)="removeToast(toast.id)"
                [attr.data-automation-id]="automationId + '-exit-button'" title="Close" aria-label="Close">
                <i class="fa fa-close"></i>
            </button>
        </div>
    </div>
</div>